<template>
  <basic-container>

    <!-- 搜索end -->
    <el-tabs v-model="activeTab" @tab-click="handleClick" >
      <el-tab-pane label="列表展示" name="listMode">
        <!-- 列表展示 -->
        <!-- 搜索 -->
        <el-form label-width="80px" size="small">
          <el-row :gutter="20">
            <el-col span="6">
              <el-form-item label="项目名称">
                <el-select
                  v-model="query.projectId"
                  placeholder="请选择项目名称"
                  @change="projectChange"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in projectList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同类型">
                <el-select v-model="query.type" placeholder="请选择合同类型" style="width: 100%">
                  <el-option
                    v-for="(item, index) in contractTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同对象">
                <el-select
                  v-model="query.partnerId"
                  placeholder="请选择合同对象"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in partnerList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同状态">
                <el-select
                  v-model="query.lifecycleIndex"
                  placeholder="请选择合同状态"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in lifeCycleList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="审核状态">
                <el-select
                  v-model="query.approveStatus"
                  placeholder="请选择审核状态"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in approveStatusList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="有效期至">
                <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.timeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.timeEnd"
              type="date"
              value-format="yyyy-MM-dd"
             
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="合同编号">
                <el-input style="width: 100%" v-model="query.code" />
              </el-form-item>
            </el-col>
            <el-col span="4">
              <el-button type="primary" @click="searchChange" size="small"> 搜索 </el-button>
              <el-button @click="searchClear" size="small"> 重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
          @sort-change="sortChange"
        >
        <template slot="menuRight">
             <wq-showHidden :column.sync="option.column" :moduleType="moduleType" ></wq-showHidden>
           </template>
          <template slot="lifecycleIndex" slot-scope="scope">
            <!-- <el-tag :class="'client-status-class-' + scope.row.lifecycleIndex"> -->
            <el-tag>
              {{
                tool.getDictionaryValue(
                  lifeCycleList,
                  'dictValue',
                  'dictKey',
                  scope.row.lifecycleIndex
                )
              }}
            </el-tag>
          </template>
          <template slot="approveStatus" slot-scope="scope">
            <!-- <el-tag :class="'client-status-class-' + scope.row.approveStatus"> -->
            <el-tag>
              {{
                tool.getDictionaryValue(
                  approveStatusList,
                  'dictValue',
                  'dictKey',
                  scope.row.approveStatus
                )
              }}</el-tag
            >
          </template>
          <template slot="overflowFlag" slot-scope="scope">
               <div class="money"><span>{{tool.money_format_allowvoid(scope.row.overflowFlag)  }}</span></div>
          </template>
          <template slot="money" slot-scope="scope">
               <div class="money"><span>{{tool.money_format_allowvoid(scope.row.money)  }}</span></div>
          </template>
          <template slot="contractPayment" slot-scope="scope">
               <div class="money"><span>{{tool.money_format_allowvoid(scope.row.contractPayment)  }}</span></div>
          </template>
          <template slot="contractNoPayment" slot-scope="scope">
               <div class="money"><span>{{tool.money_format_allowvoid(scope.row.contractNoPayment)  }}</span></div>
          </template>
          <template slot="menuLeft">
            <el-button type="success" plain size="small" icon="el-icon-upload2" @click="importForm"
              >导入
            </el-button>
             <!-- <el-button type="warning" plain size="small" icon="el-icon-download" @click="exportExcelSelection"
              >导出
            </el-button> -->
             <wq-exportData :moduleType="moduleType" @exportExcel="exportExcel"></wq-exportData>
            <!-- <wq-exportData></wq-exportData> -->

            <!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="exportDemoExcel"
              >导出模板
            </el-button> -->
          </template>

          <!-- 行操作按钮 -->
          <template slot-scope="scope" slot="menu">
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              @click="handleRowAction(scope.row, 'view')"
              >查看
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              v-if="scope.row.approveStatus === 0 || scope.row.approveStatus === 2"
              @click="handleRowAction(scope.row, 'edit')"
              >修改
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              v-if="scope.row.approveStatus === 1 && [1, 2, 4].includes(scope.row.lifecycleIndex)"
              @click="handleRowAction(scope.row, 'edit')"
              >变更
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-setting"
              v-if="scope.row.approveStatus === 0"
              @click="handleRowAction(scope.row, 'approve')"
              >审核
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              v-if="scope.row.approveStatus === 0 || scope.row.approveStatus === 2"
              @click="handleRowAction(scope.row, 'delete')"
              style="color: #ff0000"
              >删除
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document-checked"
              v-if="scope.row.approveStatus === 1 && scope.row.lifecycleIndex === 4"
              @click="handleRowAction(scope.row, 'finish')"
              >完结
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document-delete"
              v-if="
                scope.row.approveStatus === 1 &&
                (scope.row.lifecycleIndex === 1 || scope.row.lifecycleIndex === 2)
              "
              @click="handleRowAction(scope.row, 'terminate')"
              >解除
            </el-button>
          </template>
        </avue-crud>
        <el-dialog
          title="合同台账数据导入"
          append-to-body
          :visible.sync="showUploadDialog"
          width="555px"
          accept="vnd.ms-excel"
          :close-on-click-modal="false"
        >
          <avue-form
            id="contractFileListStyle20210419"
            :option="excelOption"
            v-model="upload"
            :upload-after="uploadAfter"
            @on-success="test"
          >
            <template slot-scope="scope" slot="downloadAction">
                模板下载:
                <el-button type="primary" size="small" icon="el-icon-download" @click="exportDemoExcel">
                  模板下载
                </el-button>
                <!-- <el-button @click="tip">自定义按钮</el-button> -->
            </template>
          </avue-form>
        </el-dialog>
        <el-dialog
          title="审核"
          :visible.sync="approvereShowDialogFlag"
          append-to-body
          v-loading="loading"
          :close-on-click-modal="false"
        >
          <div class="el-property-dialog-div">
            <avue-form
              v-if="approvereShowDialogFlag"
              ref="approvereFormRef"
              v-model="approveForm"
              :option="approveOption"
            >
              <template slot-scope="" slot="remark">
                <el-input
                  type="textarea"
                  :rows="6"
                  maxlength="500"
                  show-word-limit
                  placeholder="请输入内容"
                  v-model="approveForm.remark"
                >
                </el-input>
              </template>
              <template slot-scope="" slot="menuForm">
                <el-button type="primary" @click="approveExec(1)"> 审核通过 </el-button>
                <el-button type="warning" @click="approveExec(2)"> 审核驳回 </el-button>
              </template>
            </avue-form>
          </div>
        </el-dialog>
        <!-- form -->
        <el-dialog
          :visible.sync="addAndEdit.show"
          append-to-body
          width="80%"
          :close-on-click-modal="false"

        >
          <Index
            v-if="addAndEdit.show"
            :pageMode="addAndEdit.pageMode"
            :id="addAndEdit.contractId"
            @closeDialog="closeDialog"
          />
        </el-dialog>
        <!-- 执行 -->
        <el-dialog :visible.sync="executeShow" append-to-body width="80%" :before-close="executeClose"
                   :close-on-click-modal="false">
          <Execution
            v-if="executeShow"
            :contractId="executeContractId"
            :permission="executePermission"
            @closeDialog="executeClose"
            :contractTypeList="contractTypeList"
            :lifeCycleList="lifeCycleList"
          />
        </el-dialog>
        <div class="pagination">
      <el-pagination
        background
        layout="total,sizes,prev, pager, next,jumper"
        :total="page.total"
        :page-sizes="page.pageSizes"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
      </el-tab-pane>
      <!-- 看板模式 -->
      <el-tab-pane label="看板展示" name="paneMode" v-loading="loading">
        <el-form label-width="80px" size="small">
          <el-row :gutter="20">

            <el-col span="6">
              <el-form-item label="项目名称">
                <el-select
                  v-model="query.projectId"
                  placeholder="请选择项目名称"
                  @change="projectChangeBorad"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in projectList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="签订日期">
                <div style="display: flex;">
        <el-date-picker
              style="width:42%;"
              v-model="query.signTimeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              placeholder="开始日期"
           
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.signTimeEnd"
              type="date"
              value-format="yyyy-MM-dd"
             
              placeholder="结束日期"
            >
            </el-date-picker>
      </div>
              </el-form-item>
            </el-col>
             <el-col span="6">
              <el-form-item label="合同类型">
                <el-select v-model="query.type" placeholder="请选择合同类型" style="width: 100%">
                  <el-option
                    v-for="(item, index) in contractTypeList"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="4">
              <el-button type="primary" @click="boardSearchInfo" size="small"> 搜索 </el-button>
              <el-button @click="boardSearchClear" size="small"> 重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
        <div class="boardList" >
            <bulletin-board
            ref="board0"
            :projectContractTypeList="projectContractTypeList"
              @onLoad="( (current)=>{
                return boardOnload(current,boardList.noPerformance)
                })"
              :loadFlag='boardList.noPerformance.boardListLoadFlag'
              :scrollBottom ='boardList.noPerformance.scrollBottom'
              :total='boardList.noPerformance.total'
              :list="boardList.noPerformance.list"
              :option="{color:'#2E8B78',title:'未履行'}"
              :info="boardList.noPerformance.info"
              :clearCurrent="clearCurrent"
              @getDetail="getDetail"   ></bulletin-board>
            <bulletin-board
            ref="board1"
            :projectContractTypeList="projectContractTypeList"
              @onLoad="( (current)=>{
                return boardOnload(current,boardList.performing)
                })"
              :loadFlag='boardList.performing.boardListLoadFlag'
               :scrollBottom ='boardList.performing.scrollBottom'
              :total='boardList.performing.total'
              :list="boardList.performing.list"
              :info="boardList.performing.info"
              :clearCurrent="clearCurrent"
              @getDetail="getDetail"
              :option="{color:'#7CC23A',title:'履行中'}"></bulletin-board>
            <bulletin-board
            ref="board2"
              :projectContractTypeList="projectContractTypeList"
               @onLoad="( (current)=>{
                return boardOnload(current,boardList.expired)
                })"
              :loadFlag='boardList.expired.boardListLoadFlag'
              :scrollBottom ='boardList.expired.scrollBottom'
              :total='boardList.expired.total'
              :list="boardList.expired.list"
              :info="boardList.expired.info"
              :clearCurrent="clearCurrent"
              @getDetail="getDetail"
              :option="{color:'#F56C6C',title:'已到期'}"></bulletin-board>
            <bulletin-board
            ref="board3"
              :projectContractTypeList="projectContractTypeList"
              @onLoad="( (current)=>{
                return boardOnload(current,boardList.end)
                })"
              :loadFlag='boardList.end.boardListLoadFlag'
              :scrollBottom ='boardList.end.scrollBottom'
              :total='boardList.end.total'
              :list="boardList.end.list"
              :info="boardList.end.info"
              :clearCurrent="clearCurrent"
              @getDetail="getDetail"
              :option="{color:'#409EFF',title:'完结'}"></bulletin-board>
            <bulletin-board
            ref="board4"
              :projectContractTypeList="projectContractTypeList"
              @onLoad="( (current)=>{
                  return boardOnload(current,boardList.released)
                  })"
              :loadFlag='boardList.released.boardListLoadFlag'
              :scrollBottom ='boardList.released.scrollBottom'
              :total='boardList.released.total'
              :info="boardList.released.info"
              :list="boardList.released.list"
              :clearCurrent="clearCurrent"
              @getDetail="getDetail"
              :option="{color:'#909399',title:'已解除'}"></bulletin-board>
        </div>
        <!-- 右抽屉 -->
        <div style="width:384px">
          <el-drawer
          :title="drawerObj.name"
          :visible.sync="drawerFlag"
          :direction="rtl"
          :modal='false'
          size='384px'
          :modal-append-to-body='false'

          :before-close="handleClose">
          <div class="checkDetailInfo">
            <div>
              <div class="status" :style="'background:'+drawerObj.color">{{getBoardStatus(drawerObj.lifecycleIndex)}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">合同对象：</div>
              <div class="detail-item-value" >{{drawerObj.partnerName}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">合同类型：</div>
              <div class="detail-item-value">{{getProjectContractName(drawerObj.type)}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">合同编号：</div>
              <div class="detail-item-value">{{drawerObj.code}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">签订日期：</div>
              <div class="detail-item-value">{{drawerObj.signTime?dayjs(drawerObj.signTime).format('YYYY-MM-DD'):""}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">生效日期：</div>
              <div class="detail-item-value">{{drawerObj.validityPeriodStart?dayjs(drawerObj.validityPeriodStart).format('YYYY-MM-DD'):''}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">有效期至：</div>
              <div class="detail-item-value">{{drawerObj.validityPeriodEnd?dayjs(drawerObj.validityPeriodEnd).format('YYYY-MM-DD'):''}}</div>
            </div>
            <div class="detail-item">
              <div class="detail-item-title">合同金额：</div>
              <div class="detail-item-value">{{ tool.money_format_allowvoid(drawerObj.money) }}</div>
            </div>
             <div class="detail-item">
              <div class="detail-item-title">已结算金额：</div>
              <div class="detail-item-value">{{ tool.money_format_allowvoid(drawerObj.contractPayment)  }}</div>
            </div>
             <div class="detail-item">
              <div class="detail-item-title">未结算金额：</div>
              <div class="detail-item-value">{{ tool.money_format_allowvoid(drawerObj.contractNoPayment) }}</div>
            </div>
            <div class="operateBtn">
              <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              @click="handleRowAction(drawerObj, 'view')"
              >查看
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              v-if="drawerObj.approveStatus === 0 || drawerObj.approveStatus === 2"
              @click="handleRowAction(drawerObj, 'edit')"
              >修改
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              v-if="drawerObj.approveStatus === 1 && [1, 2, 4].includes(drawerObj.lifecycleIndex)"
              @click="handleRowAction(drawerObj, 'edit')"
              >变更
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-setting"
              v-if="drawerObj.approveStatus === 0"
              @click="handleRowAction(drawerObj, 'approve')"
              >审核
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              v-if="drawerObj.approveStatus === 0 || drawerObj.approveStatus === 2"
              @click="handleRowAction(drawerObj, 'delete')"
              style="color: #ff0000"
              >删除
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document-checked"
              v-if="drawerObj.approveStatus === 1 && drawerObj.lifecycleIndex === 4"
              @click="handleRowAction(drawerObj, 'finish')"
              >完结
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-document-delete"
              v-if="
                drawerObj.approveStatus === 1 &&
                (drawerObj.lifecycleIndex === 1 || drawerObj.lifecycleIndex === 2)
              "
              @click="handleRowAction(drawerObj, 'terminate')"
              >解除
            </el-button>
            </div>
          </div>
        </el-drawer>
        </div>

      </el-tab-pane>
    </el-tabs>

    <el-dialog title="导出数据" :visible.sync="exportExcelSelectionBoxFlag" append-to-body width="30%"
               :close-on-click-modal="false">
        <div style="text-align:center;padding:2rem 0;">
          <el-radio v-model="exportExcelSelectionRadio" label="1">导出全部数据</el-radio>
          <el-radio v-model="exportExcelSelectionRadio" label="2">导出已选数据</el-radio>
        </div>
        <div style="text-align:center;">
          <el-button type="primary" @click="exportExcel">确定</el-button>
          <el-button type="info" @click="exportExcelSelectionBoxFlag=false">取消</el-button>
        </div>
    </el-dialog>
  </basic-container>
</template>

<script>
const SIZE = 10 //看板每次加载数据长度
const SCOLLSIZE =4
import {
  getList,
  terminate,
  finish,
  removeById,
  approve,
  getPartnerList,
  getDictData,
  getContractTotalMoney//获取合同5个状态总金额金额信息
} from '@/api/crmedical/contract/contract/contract';
import bulletinBoard from '@/components/bulletinBoard';//
import { mapGetters } from 'vuex';
import { getProjectList } from '@/api/crmedical/project/project';
import { getProjectDict } from '@/api/crmedical/project-dictionary/project-dictionary';
import Index from '../add/index.vue';
import Execution from '../execution/index.vue';
import { getToken } from '@/util/auth';
import {getPersonalConfig} from "@/api/wel/home.js"
import dayjs from 'dayjs';
import { log } from 'util';
import { setTimeout } from 'timers';

export default {
  components: { Index, Execution, bulletinBoard},
  data() {
    return {
      searchForm:{},
      moduleType:301,
      clearCurrent:false,
      typeList:[],//合同字典类型
      projectContractTypeList:[],//合同字典类型
      boardListLoadFlag : true,
      drawerObj:{},//抽屉数据
      boardList:{
        noPerformance:{//未履行
          status:1,
          boardListLoadFlag:true,
          list:[],
          info:{},
          total:0,
          scrollBottom:false
        },
        performing:{//履行中
          boardListLoadFlag:true,
          list:[],
          info:{},
          total:0,
          status:2,
          scrollBottom:false
        },
        expired:{//已到期
          list:[],
          info:{},
          total:0,
          boardListLoadFlag:true,
          status:4,
          scrollBottom:false
        },
        end:{//完结
          list:[],
          info:{},
          total:0,
          boardListLoadFlag:true,
          status:5,
          scrollBottom:false
        },
        released:{//已解除
          list:[],
          info:{},
          total:0,
          boardListLoadFlag:true,
          status:3,
          scrollBottom:false
        }
      },
      boardSearch:{
        projectId:'',
        signTimeStart:'',//签订日期
        signTimeEnd :'',//结束日期
        type:''

      },
      drawerFlag:false,
      exportExcelSelectionRadio:'1',
      exportExcelSelectionBoxFlag:false,
      contractIds:'',
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/v4ward/contract/imporContract',
          },
          {
            label: '模板下载',
            prop: 'downloadAction',
            formslot: true
          }
        ],
      },
      showUploadDialog: false,
      executeShow: false, //执行dialog显隐
      executeContractId: '', //执行的合同Id
      executePermission: false,
      //列表展示模式:listMode->列表展示;paneMode->看板模式
      activeTab: 'listMode',
      query: {
        projectId: '',
        type: '',
        partnerId: '',
        lifecycleIndex: '',
        approveStatus: '',
        timeRange: [],
        code: '',
        boardTimeRange:[],//看板时间,
        timeStart: '',
        timeEnd:'',
        signTimeStart:'',
        signTimeEnd:'',
      },
      contractTypeList: [], //合同类型列表
      lifeCycleList: [], //合同状态(生命周期)列表
      approveStatusList: [], //审核状态列表
      partnerList: [], //合同对象列表
      data: [], //合同列表数据
      projectList: [], //项目列表
      //审核相关
      approveOption: {
        align: 'center',
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: '主键id',
            prop: 'contractId',
            display: false,
          },
          {
            label: '备注',
            prop: 'remark',
            formslot: true,
            span: 24,
            type: 'textarea',
            minRows: 6,
            maxlength: 500,
            rules: [
              {
                required: false,
                message: '请输入备注',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      approvereShowDialogFlag: false,
      approveForm: {
        contractId: '',
        remark: '',
      },
      addAndEdit: {
        show: false,
        pageMode: 1,
        contractId: '',
      },
      form: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
        pageSizes: [10, 20, 30, 40, 50, 100],
      },
      sortObj: {
        prop: 'signTime',
        order: 'descending',
      },
      option: {selection: true,reserveSelection:true,
      height:'auto',
      calcHeight:100,
        viewBtn: false,
        index: true,
        indexLabel: '序号',
        delBtn: false,
        editBtn: false,
        addBtn: true,
        refreshBtn: false,
        columnBtn:false,
        border:true,
        align:'center',
        defaultSort: {
          prop: 'signTime',
          order: 'descending',
        },
        column: [
          {
            label: '项目名称',
            prop: 'projectName' ,
            order:12,
            searchOrder:12,
            showColumn:true,
          },
          {

            label: '合同编号',
            prop: 'code' ,
            order:11,
            searchOrder:11,
            showColumn:true,
          },
            { label: '合同名称',
              prop: 'name' ,
              order:10,
              searchOrder:10,
              showColumn:true,
          },
          {
            order:9,
            searchOrder:9,
            showColumn:true,
            label: '合同类型',
            prop: 'type',
            type: 'select',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          { label: '合同对象', prop: 'partnerName',order:8,
            searchOrder:8,
            showColumn:true, },
          {
            label: '签订日期',
            sortable: true,
            order:7,
            searchOrder:7,
            showColumn:true,
            prop: 'signTime',
            type: 'datetime',
            format: 'yyyy-MM-dd',
            minWidth: '140',
          },
          { label: '合同金额', prop: 'money', align: 'right',
            minWidth:'120',
            showColumn:true,
            slot:true},
           {label: '已结算金额', prop: 'contractPayment', align: 'right',
            minWidth:'120',
            showColumn:true,
            slot:true
            },
           {label: '未结算金额', prop: 'contractNoPayment', align: 'right',
            minWidth:'120',
            showColumn:true,
            slot:true},
          // { label: '账款金额', prop: 'formatedContractPayment', align: 'right' },

          // { label: '账款金额', prop: 'formatedContractPayment', align: 'right',order:5,
          //   searchOrder:5,
          //   minWidth:'120',
          //   showColumn:true, },
          {
            label: '生效日期',
            sortable: true,
            order:4,
            searchOrder:4,
            showColumn:true,
            prop: 'validityPeriodStart',
            type: 'datetime',
            format: 'yyyy-MM-dd',
            minWidth:'140',
          },
          {
            label: '有效期至',
            sortable: true,
            order:3,
            searchOrder:3,
            showColumn:true,
            prop: 'validityPeriodEnd',
            type: 'datetime',
            format: 'yyyy-MM-dd',
            minWidth:'140',
          },

          {
            order:2,
            searchOrder:2,
            showColumn:true,
            label: '审核状态',
            prop: 'approveStatus',
            slot: true,
            minWidth:'120',
          },
          {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '状态',
            prop: 'lifecycleIndex',
            slot: true,
          },
          {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '质保期至',
            prop: 'warrantyPeriodEnd',

          },
          {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '收费款类型',
            prop: 'paymentType',
            type: 'select',
              dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl:
              '/api/blade-system/dict/dictionary?code=contract_payment_type'

          },
          {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '允许超额',
            prop: 'overflowFlag',
            slot:true,

          },
           {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '签订部门',
            prop: 'signDept',

          },
          {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '责任人',
            prop: 'chargeManName',

          },
          {
            order:1,
            searchOrder:1,
            showColumn:true,
            label: '合同备注',
            prop: 'description',

          },
        ],
      },
    };
  },
  watch:{
    activeTab(val,oldVal){
      if(val == 'paneMode'){
        this.boardSearchInfo()
      }
    },
    "option.column"(){
      this.$refs.crud.selectClear();
      this.contractIds = "";
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.contract_add, false),
        viewBtn: this.vaildData(this.permission.contract_view, false),
        delBtn: this.vaildData(this.permission.contract_delete, false),
        editBtn: this.vaildData(this.permission.contract_edit, false),
        approveBtn: this.vaildData(this.permission.contract_approve, false),
        executeBtn: this.vaildData(this.permission.contract_execute, false),
        terminateBtn: this.vaildData(this.permission.contract_terminate, false),
      };
    },
  },
  created() {
    getProjectList().then((res) => {
      this.projectList = res.data;
      if (this.projectList.length > 0) {
        this.$set(this.query, 'projectId', this.projectList[0].id);
         this.$set(this.boardSearch, 'projectId', this.projectList[0].id);
        this.projectChange(this.query.projectId);
      }
    });
    // this.boardSearchInfo()
    //加载合同状态(生命周期)
    this.loadProjectLifeCycle();
    //加载合同审核状态
    this.loadApproveStatus();
  },
  methods: {
    executeClose(){
      console.log("查看关闭")
      this.executeShow = false
      if(this.activeTab=='paneMode'){
        this.boardSearchInfo()
      }else{
         this.onLoad();
      }
    },
    indexClose(){
      // this.boardSearchInfo()
    },
    //清空看板搜索条件
    boardSearchClear(){
      this.query.boardTimeRange = []
      this.query.type = ''
      this.query.signTimeStart = ''
      this.query.signTimeEnd = ''
      this.boardSearch.timeStart = ''
      this.boardSearch.timeEnd = ''
    },
    //看板状态
    getBoardStatus(val){
      switch(val) {
        case 1:
            return '未履行'
        case 2:
             return '履行中'
        case 4:
            return '已到期'
        case 5:
            return '完结'
        case 3:
            return '已解除'
      }
    },
    //看板到底部加载
   async boardOnload(current,obj){
     console.log(obj.list.length,obj.total)

          if(obj.boardListLoadFlag){
            console.log('下拉加载：',current)
            let arry =(await this.getBoardList(obj.status,current)).records

            arry.forEach(item=>{
              obj.list.push(item)
            })
          }
          if(obj.list.length==obj.total){
            obj.boardListLoadFlag = false
          }
    },
    //看板条件搜索
    async boardSearchInfo(){
      this.clearCurrent=!this.clearCurrent//判断是否清数据请求空页码
      for(let i =0;i<5;i++){
        this.$refs["board"+i].scrollBottom = false
        this.$refs["board"+i].total = -1
      }
      console.log(this.query.boardTimeRange)
     
      // if(this.query.boardTimeRange&&this.query.boardTimeRange.length>0){
      //   this.boardSearch.signTimeStart = this.query.boardTimeRange[0]
      // this.boardSearch.signTimeEnd = this.query.boardTimeRange[1]
      // }else{
      //   this.query.boardTimeRange = []
      //   this.boardSearch.signTimeStart = ''
      //   this.boardSearch.signTimeEnd = ''
      // }
      this.boardSearch. signTimeEnd=this.query.signTimeEnd
      this.boardSearch.signTimeStart = this.query.signTimeStart
      this.boardSearch.projectId = this.query.projectId
      this.boardSearch.type = this.query.type
      let {data : totalMoney} = await  getContractTotalMoney(this.boardSearch)
      console.log(totalMoney)
      this.boardProjectChange(this.boardSearch.projectId)
      let noPerformance = await this.getBoardList(1,1)
      this.boardList.noPerformance.list = noPerformance.records;
      this.boardList.noPerformance.boardListLoadFlag = noPerformance.records.length ==noPerformance.total?false:true
      this.boardList.noPerformance.total = noPerformance.total;
      this.boardList.noPerformance.scrollBottom = noPerformance.total<SCOLLSIZE?true:false
      this.boardList.noPerformance.info.moneySum = totalMoney[0]['1']?totalMoney[0]['1'].contractAmountSum:''
      this.boardList.noPerformance.info.settledAmountSum  =totalMoney[0]['1']?totalMoney[0]['1'].totalPaidAmountSum:''
      this.boardList.noPerformance.info.unsettledAmountSum   = totalMoney[0]['1']?totalMoney[0]['1'].totalUnPaidAmountSum:''
      let performing = await this.getBoardList(2,1)
      this.boardList.performing.list = performing.records;
      this.boardList.performing.boardListLoadFlag = performing.records.length ==performing.total?false:true
      this.boardList.performing.total = performing.total;
      this.boardList.performing.scrollBottom = performing.total<SCOLLSIZE?true:false
      this.boardList.performing.info.moneySum = totalMoney[0]['2']?totalMoney[0]['2'].contractAmountSum:''
      this.boardList.performing.info.settledAmountSum  =totalMoney[0]['2']?totalMoney[0]['2'].totalPaidAmountSum:''
      this.boardList.performing.info.unsettledAmountSum   =totalMoney[0]['2']?totalMoney[0]['2'].totalUnPaidAmountSum:''
      let expired = await this.getBoardList(4,1)
      this.boardList.expired.list = expired.records;
      this.boardList.expired.boardListLoadFlag = expired.records.length ==expired.total?false:true
      this.boardList.expired.total = expired.total;
      this.boardList.expired.scrollBottom = expired.total<SCOLLSIZE?true:false
      this.boardList.expired.info.moneySum =  totalMoney[0]['4']?totalMoney[0]['4'].contractAmountSum:''
      this.boardList.expired.info.settledAmountSum  =totalMoney[0]['4']?totalMoney[0]['4'].totalPaidAmountSum:''
      this.boardList.expired.info.unsettledAmountSum   =totalMoney[0]['4']?totalMoney[0]['4'].totalUnPaidAmountSum:''
      let end = await this.getBoardList(5,1)
      this.boardList.end.list = end.records;
      this.boardList.end.boardListLoadFlag = end.records.length ==end.total?false:true
      this.boardList.end.total = end.total;
      this.boardList.end.scrollBottom = end.total<SCOLLSIZE?true:false
      this.boardList.end.info.moneySum = totalMoney[0]['5']?totalMoney[0]['5'].contractAmountSum:''
      this.boardList.end.info.settledAmountSum  =totalMoney[0]['5']?totalMoney[0]['5'].totalPaidAmountSum:''
      this.boardList.end.info.unsettledAmountSum   =totalMoney[0]['5']?totalMoney[0]['5'].totalUnPaidAmountSum:''
      let released = await this.getBoardList(3,1)
      this.boardList.released.list = released.records;
      this.boardList.released.boardListLoadFlag = released.records.length ==released.total?false:true
      this.boardList.released.total = released.total;
      this.boardList.released.scrollBottom = released.total<SCOLLSIZE?true:false
      this.boardList.released.info.moneySum = totalMoney[0]['3']?totalMoney[0]['3'].contractAmountSum:''
      this.boardList.released.info.settledAmountSum  =totalMoney[0]['3']?totalMoney[0]['3'].totalPaidAmountSum:''
      this.boardList.released.info.unsettledAmountSum   = totalMoney[0]['3']?totalMoney[0]['3'].totalUnPaidAmountSum:''

    },
   async getBoardList(lifecycleIndex,current){
      let obj
      await  getList({
          current:current,
          size: SIZE,
          ...Object.assign({lifecycleIndex},this.boardSearch)
        }, ).then(({data})=>{
          obj = data
        })
        return obj
    },
    //获取点击看板弹出抽屉的数据
    getDetail(val){
      this.drawerObj = val
      this.drawerFlag = true
    },
    selectionChange(val){
      console.log(val);
      let Ids = [];
      val.forEach(element => {
        Ids.push(element.id);
      });
      this.contractIds = Ids.join(',');
    },
    sortChange(sortObj) {
      this.sortObj = sortObj;
      this.page.current = 1;
      this.onLoad();
    },
    searchChange() {
      this.page.currentPage = 1
      if (this.loading) return;
      this.page.currentPage = 1 
      this.onLoad();
    },
    boardProjectChange(val){
      getProjectDict({
          projectId: val,
          code: 'project_contract_type',
        }).then(({data})=>{
         this.projectContractTypeList = data
         console.log(this.projectContractTypeList)
        })
    },
     boardTypeChange(val){
       this.boardSearch.type = ""
      getProjectDict({
          projectId: val,
          code: 'project_contract_type',
        }).then(({data})=>{
         this.typeList = data
        })
    },
    getProjectContractName(dictKey) {
      let ProjectContractName;
      this.projectContractTypeList.forEach((element) => {
        if (element.dictKey == dictKey) {
          ProjectContractName = element.dictValue;
        }
      });
      return ProjectContractName;
    },
    projectChange(val) {
      this.$set(this.query, 'type', '');
      this.$set(this.query, 'partnerId', '');
      Promise.all([
        getProjectDict({
          projectId: val,
          code: 'project_contract_type',
        }),
        getPartnerList({ id: val }),
      ]).then((res) => {
        this.contractTypeList = res[0].data;
        this.partnerList = res[1].data;
        this.$refs.crud.updateDic('type', this.contractTypeList);
        this.onLoad();
      });
    },
    projectChangeBorad(val){
      this.$set(this.query, 'type', '');
      this.$set(this.query, 'partnerId', '');
      Promise.all([
        getProjectDict({
          projectId: val,
          code: 'project_contract_type',
        }),
        getPartnerList({ id: val }),
      ]).then((res) => {
        this.contractTypeList = res[0].data;
        this.partnerList = res[1].data;
        this.$refs.crud.updateDic('type', this.contractTypeList);

      });
    },
    uploadAfter(res, done) {
      if (!res) {
        this.$message({
          message: '上传成功！',
          type: 'success',
        });
        this.showUploadDialog = false;
        this.onLoad();
      }
      done();
    },
    //导入数据
    importForm() {
      console.log('打开上传表单...');
      this.showUploadDialog = true;
    },
    exportExcelSelection(){
      this.exportExcelSelectionBoxFlag = true;
    },
    //导出合同台账数据
    exportExcel(data) {
      let saveIds = data.exportExcelSelectionRadio=='1'?'':this.contractIds;
      console.log(saveIds)
      if(saveIds.length==0 && data.exportExcelSelectionRadio == 2){
              this.$message({
                      message:'请选择需要导出的数据！',
                      type: 'warning'
              });
              return;
      }
      this.$confirm('是否导出合同台账数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        let projectId = '';
        if (this.searchForm.projectId) {
          projectId = this.searchForm.projectId;
        }
        let type = '';
        if (this.searchForm.type) {
          type = this.searchForm.type;
        }
        let partnerId = '';
        if (this.searchForm.partnerId) {
          partnerId = this.searchForm.partnerId;
        }
        let lifecycleIndex = '';
        if (this.searchForm.lifecycleIndex) {
          lifecycleIndex = this.searchForm.lifecycleIndex;
        }
        let approveStatus = '';
        if (this.searchForm.approveStatus) {
          approveStatus = this.searchForm.approveStatus;
        }
        let timeStart = '';
        let timeEnd = '';
        if( this.vdui.isEmpty(this.searchForm.timeStart)||this.vdui.isEmpty(this.searchForm.timeEnd)){
          timeStart = '';
          timeEnd = '';
        
      }else{
        timeStart = this.searchForm.timeStart;
          timeEnd = this.searchForm.timeEnd;
      }
       
        let code = '';
        if (this.searchForm.code) {
          code = this.searchForm.code || '';
        }
        if(data.exportExcelSelectionRadio == 2){
          window.open(
            `/api/v4ward/personal/config/export/default/contractExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&projectId=${projectId}&saveIds=${saveIds}`
          );
        }else{
          window.open(
            `/api/v4ward/personal/config/export/default/contractExport?${
              this.website.tokenHeader
            }=${getToken()}&configExport=${data.configExport}&projectId=${projectId}&type=${type}&partnerId=${partnerId}&lifecycleIndex=${lifecycleIndex}&approveStatus=${approveStatus}&timeStart=${timeStart}&timeEnd=${timeEnd}&code=${code}`
          );
        }

      });
    },
    //导出模板
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出设备设施模版
        window.open(
          `/api/v4ward/contract/exportDemoExcel?${
            this.website.tokenHeader
          }=${getToken()}&projectId=` + this.query.projectId
        );
      });
    },
    // 清空搜索
    searchClear() {
      this.query = Object.assign({}, this.query, {
        type: '',
        partnerId: '',
        lifecycleIndex: '',
        approveStatus: '',
        timeRange: [],
        timeStart: '',
        timeEnd:'',
        code: '',
      });
      this.sortObj = {
        prop: 'signTime',
        order: 'descending',
      };
      this.onLoad();
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad();
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad();
    },
    //加载合同状态(生命周期)
    loadProjectLifeCycle() {
      getDictData({ code: 'contract_lifecycle' }).then((res) => {
        this.lifeCycleList = res.data;
      });
    },
    //加载合同审核状态
    loadApproveStatus() {
      getDictData({ code: 'approve_status' }).then((res) => {
        this.approveStatusList = res.data;
      });
    },
    terminate(row) {
      if (row.lifecycleIndex == 3) {
        this.$message.warning('该合同已为解除状态！');
        return;
      }
      this.$confirm('是否选择终止合同', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return terminate({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleRowAction(row, type) {
      if (type == 'view') {
        this.executeContractId = row.id;
        this.executePermission = [1, 2, 4].includes(row.lifecycleIndex) && row.approveStatus === 1;
        this.drawerFlag = false;
        this.executeShow = true;
      } else if (type == 'edit') {
        this.addAndEdit.pageMode = 2;
        this.addAndEdit.contractId = row.id;
         this.drawerFlag = false;
        this.addAndEdit.show = true;
      } else if (type == 'approve') {
        this.approveForm.remark = '';
        this.approveForm.contractId = row.id;
        this.drawerFlag = false;
        this.approvereShowDialogFlag = true;
      } else if (type == 'delete') {
        this.$confirm('是否删除合同?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return removeById({ id: row.id });
          })
          .then(() => {
            this.onLoad();
            this.drawerFlag = false;
            this.$message.success('操作成功!');
            if(this.activeTab=='paneMode'){
              this.boardSearchInfo()
            }
          });
      } else if (type == 'finish') {
        this.$confirm('是否完结合同?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return finish({ id: row.id });
          })
          .then(() => {
            this.onLoad();
            this.drawerFlag = false;
            this.$message.success('操作成功!');
          });
      } else if (type == 'terminate') {
        this.$confirm('是否解除合同?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return terminate({ id: row.id });
          })
          .then(() => {
            this.onLoad();
            this.drawerFlag = false;
            this.$message.success('操作成功!');
            if(this.activeTab=='paneMode'){
              this.boardSearchInfo()
            }
          });
      } else {
        console.log('tag error==>');
      }
    },
    beforeOpen(done, type) {
      if (type == 'add') {
        this.addAndEdit.pageMode = 1;
        this.addAndEdit.contractId = '';
        this.addAndEdit.show = true;
      }
    },
    closeDialog(type) {
      this.addAndEdit.show = false;
      if(this.activeTab=='paneMode'){
        this.boardSearchInfo()
      }
      this.onLoad();
    },
    //审批
    approveExec(status) {
      this.approveForm.approveStatus = status;
      let tipMessage = status === 1 ? '是否通过？' : '是否驳回？';
      this.$refs.approvereFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$confirm(tipMessage, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => approve(this.approveForm))
            .then((res) => {
              this.$message.success(res.msg);
              this.onLoad();
              this.approvereShowDialogFlag = false;
              this.loading = false;
              if(this.activeTab=='paneMode'){
                this.boardSearchInfo()
              }
            })
            .catch((err) => {
              err === 'cancel' ? this.$message.info('已取消') : this.$message.error(err);
              this.loading = false;
            });
        }
      });
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      let params = {
        projectId: this.query.projectId,
        type: this.query.type,
        partnerId: this.query.partnerId,
        lifecycleIndex: this.query.lifecycleIndex,
        approveStatus: this.query.approveStatus,
        code: this.query.code,
      };
      //排序
      params['orderItem.asc'] = this.sortObj.order === 'ascending';
      if (String.prototype.replaceAll) {
        params['orderItem.column'] = this.sortObj.prop.replaceAll(
          /[A-Z]/g,
          (item) => '_' + item.toLowerCase()
        );
      } else {
        let prop = this.sortObj.prop;
        let transProp = '';
        switch (prop) {
          case 'signTime':
            transProp = 'sign_time';
            break;
          case 'validityPeriodStart':
            transProp = 'validity_period_start';
            break;
          case 'validityPeriodEnd':
            transProp = 'validity_period_end';
            break;
        }
        params['orderItem.column'] = transProp;
      }
     
        params.timeStart = this.query.timeStart;
        params.timeEnd = this.query.timeEnd;
      
      
      this.searchForm = JSON.parse(JSON.stringify(params))
      getList({
        current: page.currentPage,
        size: page.pageSize,
        ...params,
      }).then(({ data }) => {
        this.page.total = data.total;
        data.records.forEach((item) => {
          item.type += '';
          item.formatedMoney = isNaN(parseFloat(item.money))
            ? ''
            : parseFloat(item.money);
          item.formatedContractPayment = isNaN(parseFloat(item.contractPayment))
            ? ''
            : parseFloat(item.contractPayment).toLocaleString();
        });
        this.data = data.records;
        console.log(data.records)
        this.loading = false;
      });
    },
    getLifecycleStyleStatus(lifecycleIndex) {
      let str = '';
      switch (lifecycleIndex) {
        case 1:
          str = 'color:#777777;background:rgba(119,119,119,0.2)';
          break;
        case 2:
          str = 'color:#2cbe62;background:rgba(44,190,98,0.2)';
          break;
        case 3:
          str += 'color:#f99d35;background:rgba(249,157,53,0.2)';
          break;
        case 4:
          str += 'color:#ff7368;background:rgba(255,115,104,0.2)';
          break;
        case 5:
          str += 'color:#4da6ff;background:rgba(77,166,255,0.2)';
          break;
      }
      return str;
    },
    getLifecycleStyleMark(lifecycleIndex) {
      let str = '';
      switch (lifecycleIndex) {
        case 1:
          str = 'background-color:#777777;';
          break;
        case 2:
          str = 'background-color:#2cbe62;';
          break;
        case 3:
          str += 'background-color:#f99d35;';
          break;
        case 4:
          str += 'background-color:#ff7368;';
          break;
        case 5:
          str += 'background-color:#4da6ff;';
          break;
      }
      return str;
    },
  },
  mounted() {
    //resizie的bug
    this.$refs.crud.$refs.table.doLayout();
    setTimeout(()=>{
      window.onresize = () => {
        this.$refs.crud.$refs.table.doLayout();
        this.$store.state.windowSize.screenWidth = document.documentElement.clientWidth; //窗口宽度
        this.$store.state.windowSize.screenHeight = document.documentElement.clientHeight; //窗口高度
      };
    },0)
    
  },
};
</script>
<style>
#contractFileListStyle20210419 ul {
  display: none;
}
</style>
<style lang='scss' scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
.money{
  text-align: right;
}
::v-deep .el-table th > .cell{
  line-height: 36px;
  text-align: center;
}
::v-deep .el-tabs--border-card {
  border: none;
  box-shadow: none;
}
.checkDetailInfo{
  display: grid;
  grid-template-rows: repeat(auto-fill,auto);
  grid-row-gap: 32px;
  padding: 20px;
  .status{
    width: 58px;
    height: 32px;

    border-radius: 4px;
    font-size: 12px;
    font-family: 'Segoe UI';
    font-weight: 400;
    line-height: 32px;
    color: #FFFFFF;
    text-align: center;
  }
  .detail-item{
    font-size: 14px;
    font-family:' Microsoft YaHei UI';
    font-weight: 400;
    color: #606266;

    display: grid;
    grid-template-columns: 84px auto;
     grid-column-gap: 8px;
     .detail-item-value{
         word-break: break-all
     }
  }
}

.boardList{
    display: grid;
    grid-column-gap: 16px;
    grid-template-columns: repeat(5,1fr);
    overflow: auto;
    margin-bottom:20px
}
.search {
  padding-right: 10px;
}
.tab-pane {
  min-height: 700px;
}
.container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: flex-start;
  font-size: 14px;
}
.card {
  position: relative;
  width: calc(25% - 20px);
  height: 120px;
  margin: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  .card-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 30%;
    i {
      margin: 0 20px;
    }
  }
  .card-body {
    height: 40%;
    div {
      display: flex;
      align-items: center;
      height: 50%;
      margin: 0 20px;
    }
  }
  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 30%;
    padding: 0 20px;
    .card-footer-button {
      border: 1px solid #333;
      border-radius: 2px;
      padding: 1px 4px;
      cursor: pointer;
    }
    .card-footer-status {
      border-radius: 2px;
      padding: 1px 4px;
    }
  }
  .card-mark {
    position: absolute;
    top: 0;
    left: 0;
    width: 2.5px;
    height: 33%;
    background-color: #f00;
  }
}
.pagination {
  text-align: right;
  margin: 20px 0;
}
</style>
